// extracted by mini-css-extract-plugin
export default {"category-image":"SearchMainCategories_category-image__CDYos","masonry":"SearchMainCategories_masonry__s3FEJ","masonryItem":"SearchMainCategories_masonryItem__u4FFC"};